import React from 'react'
import { useAppTranslation } from '@hooks/useAppTranslation'
import { ContactUsPanel } from '@components/contact-us-panel/ContactUsPanel'
import styles from '../styles/ErrorFooter.module.scss'

export const ErrorFooter: React.FC = () => {
  const { t } = useAppTranslation({ keyPrefix: 'error-page.footer' })

  return (
    <div className={styles.footer}>
      <ContactUsPanel />
      <span className={styles.disclaimer}>{t('disclaimer')}</span>
    </div>
  )
}
